import React from 'react';
import PropTypes from 'prop-types';

import { OSLO_GRAY, WHITE } from '@constant/colors';

const Info = ({ backgroundColor = OSLO_GRAY, iconColor = WHITE }) => (
  <svg viewBox="-1 0 13 13" focusable="false">
    <path
      d="M6 0C2.686 0 0 2.686 0 6s2.686 6 6 6 6-2.686 6-6-2.686-6-6-6z"
      fill={backgroundColor}
      fillRule="evenodd"
    />
    <path
      d="M5 5.817c0-.14.086-.817.97-.817.883 0 1.03.594 1.03.817v3.186S6.94 10 5.97 10 5 9.002 5 9.002V5.817z"
      fill={iconColor}
      fillRule="evenodd"
    />
    <ellipse
      fill={iconColor}
      fillRule="evenodd"
      cx="6"
      cy="3"
      rx="1.2"
      ry="1.2"
    />
  </svg>
);

Info.propTypes = {
  backgroundColor: PropTypes.string,
  iconColor: PropTypes.string,
};
export default Info;
